<template>
  <v-alert
    v-if="visible"
    :type="tipoAlerta"
    variant="tonal"
    class="suscripcion-banner mb-0"
    density="compact"
  >
    <template #prepend>
      <v-icon>{{ iconoBanner }}</v-icon>
    </template>
    {{ mensajeFormateado }}
  </v-alert>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { suscripcionesService } from '@/services'
import { usePermisos } from '@/composables/usePermisos'

export default {
  name: 'SuscripcionBanner',
  setup() {
    const store = useStore()
    const { esSuperAdmin } = usePermisos()
    const isAuthenticated = computed(() => store.getters['auth/isAuthenticated'])
    const suscripcionData = ref(null)

    const visible = computed(() => {
      if (esSuperAdmin.value) return false
      if (!suscripcionData.value) return false
      if (!suscripcionData.value.mostrarBanner) return false
      return true
    })

    const tipoAlerta = computed(() => {
      if (!suscripcionData.value) return 'warning'
      const estado = suscripcionData.value.estado
      if (estado === 'Vencida') return 'error'
      if (estado === 'En gracia') return 'warning'
      return 'warning'
    })

    const iconoBanner = computed(() => {
      const estado = suscripcionData.value?.estado
      if (estado === 'Vencida') return 'mdi-alert-circle'
      return 'mdi-clock-alert-outline'
    })

    const mensajeFormateado = computed(() => {
      if (!suscripcionData.value) return ''
      const data = suscripcionData.value
      const estado = data.estado

      if (estado === 'Por vencer') {
        return `Tu periodo de acceso esta por finalizar. Te quedan ${data.diasRestantes} dia(s) antes del proximo cobro.`
      }

      if (estado === 'En gracia') {
        const fechaLimite = new Date(data.fechaProximoCobro || Date.now())
        fechaLimite.setDate(fechaLimite.getDate() + (data.diasGracia || 3))
        const hoy = new Date()
        const restantes = Math.max(0, Math.ceil((fechaLimite.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24)))

        if (restantes <= 0) {
          return 'Estas en periodo de evaluacion. Realiza el pago para continuar usando la aplicacion.'
        }
        return `Estas en periodo de evaluacion. Te queda${restantes === 1 ? '' : 'n'} ${restantes} dia(s) para realizar el pago antes de que se suspenda el acceso.`
      }

      if (estado === 'Vencida') {
        return 'Tu acceso ha sido suspendido por falta de pago. Contacta al administrador para reactivar tu suscripcion.'
      }

      return data.mensaje || ''
    })

    const cargarSuscripcion = async () => {
      if (!isAuthenticated.value) return
      if (esSuperAdmin.value) return

      try {
        suscripcionData.value = await suscripcionesService.getEstadoSuscripcionHub()
      } catch (error) {
        console.debug('No se pudo cargar estado de suscripción desde Hub:', error)
      }
    }

    onMounted(() => {
      cargarSuscripcion()
    })

    return {
      visible,
      tipoAlerta,
      iconoBanner,
      mensajeFormateado
    }
  }
}
</script>

<style scoped>
.suscripcion-banner {
  border-radius: 0;
  flex: none !important;
  min-height: auto !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
